import React, { Component } from "react";
import LayoutSinNavegacion from "../../components/Layout/LayoutSinNavegacion";

class NoAcceso extends Component {
  render() {
    return (
      <LayoutSinNavegacion>
        <h1 className="h1 text-gray-900 mt-4">Acceso Denegado</h1>
        <p className="lead text-gray-800">
          La identificación no es válida para el autenticador.
        </p>
      </LayoutSinNavegacion>
    );
  }
}

export default NoAcceso;
